export default __webpack_public_path__ + "static/media/newBalance.a7a77e49.svg";